import { render } from "./ChurchDashboard.vue?vue&type=template&id=a81b7550&scoped=true"
import script from "./ChurchDashboard.vue?vue&type=script&lang=js"
export * from "./ChurchDashboard.vue?vue&type=script&lang=js"

import "./ChurchDashboard.vue?vue&type=style&index=0&id=a81b7550&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a81b7550"]])

export default __exports__